<template>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search all Jobs..">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm">
        <template #headings>
            <th>
                <strong class="text-uppercase">Reference</strong>
            </th>
            <th>
                <strong class="text-uppercase">Journey</strong>
            </th>
            <th>
                <strong class="text-uppercase">Vehicle Reg</strong>
            </th>
            <th>
                <strong class="text-uppercase">Vehicle Type</strong>
            </th>
            <th>
                <strong class="text-uppercase">Price</strong>
            </th>
            <th>
                <strong class="text-uppercase">Status</strong>
            </th>
            <th>
                <strong class="text-uppercase">Collection</strong>
            </th>
            <th>
                <strong class="text-uppercase">Delivery</strong>
            </th>
            <th>Actions</th>
        </template>
        <template #rows="{data}">
            <tr v-for="job in data" :key="job.id">
                <td>{{ job.reference }}</td>
                <td>{{ job.journey }}</td>
                <td>{{ job.vehicle_reg }}</td>
                <td>{{ job.vehicle_type }}</td>
                <td>{{ job.price }}</td>
                <td v-html="job.status"></td>
                <td v-html="job.collection" class="text-nowrap"></td>
                <td v-html="job.delivery" class="text-nowrap"></td>
                <td v-html="job.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
    import datatable from '@/components/datatable.vue';
    import { ref } from "vue";

    const props = defineProps({
        ajaxUrl: String,
    });

    const orderBy = ref('collection_date');
    const orderAsc = ref(false);
    const limit = ref(25);
    const searchTerm = ref(null);

    const setOrder = function (input) {
        if (orderBy.value === input) {
            orderAsc.value = ! orderAsc.value;
        } else {
            orderBy.value = input;
            orderAsc.value = true;
        }
    };
</script>
